import styled from 'styled-components';
import {dFlexCenter, GRAY92, LIGHT_GRAY2, mobileMedia, SHADOW_COLOR, VERY_PALE_BLUE} from '../../../../globalVariables/GlobalVariables';
import realtimeFonts from '../../fonts';
import {circle, circleWrap, percent} from '../../../tickets/components/ticketRow/ticketProgress/TicketProgress.css';
import {getColor} from '../../utils/themeUtils';

export const section = styled.div`
  flex: 1;
  padding-inline: 20px;
  border-left: 1px solid ${p => p.theme.isDarkMode ? '#666' : LIGHT_GRAY2};
  &:last-child {
    border-left: none;
  }
`;
export const title = styled.div`
  ${realtimeFonts.windowTitle}
  color: ${p=>getColor(p.theme.isDarkMode)};
  margin-bottom: 5px;
`;

export const text = styled.div`
  width: max-content;
  padding: 2px 14px;
  font-weight: bold;
  background: ${p => p.theme.isDarkMode ? '#5A5A5A' : GRAY92};
  color: ${p => getColor(p.theme.isDarkMode)};
  border-radius: 11px;
  text-align: center;
`;

export const amount = styled.div`
  ${realtimeFonts.value};
  margin-bottom: 10px;
`;
export const insightsItem = styled.div`
  &, & span {
    min-width: fit-content;
  }
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  ${realtimeFonts.text}
`;
export const insightsNumber = styled.div<{$width?: number}>`
  ${realtimeFonts.textBold}
  padding: 2px 14px;
  border-radius: 11px;
  font-weight: bold;
  background-color: ${p => p.theme.isDarkMode ? '#5A5A5A' : GRAY92};
  width: ${p=>p.$width || 50}px;
  height: 21px;
  color: ${p => getColor(p.theme.isDarkMode)};
  ${dFlexCenter}
`;

export const insights = styled.div`
  padding-bottom: 5px;
  height: 50%;
  justify-content: space-between;
  border-radius: 8px;
  display: flex;
  align-items: flex-end;
`;

export const progressWrapper = styled.div`
    position: absolute;
    inset-inline-end: 20px;
  height: 100px;
  ${mobileMedia}{
    height: 75px;
  }
  ${circleWrap}{
    width: 90px ;
    height: 90px;
    box-shadow: 0 3px 6px ${SHADOW_COLOR};
    position: unset;
    ${mobileMedia}{
      width: 75px;
      height: 75px;
    }
  }
  ${circle} {
    width: 75%;
    height: 75%;
    ${realtimeFonts.amount}
    background-color: ${p => p.theme.isDarkMode ? '#3A3A3A' : VERY_PALE_BLUE};
 }
  ${percent} {
    ${realtimeFonts.text}
    display: contents;
    height: 26px;
  }
`;

export const goalText = styled.span`
  ${realtimeFonts.smallText}
  line-height: 13px;
`;
